
import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, Gift } from "lucide-react";
import FadeIn from "@/components/FadeIn";

const ThankYouScreen = () => {
  return (
    <FadeIn>
      <Card className="text-center p-8 shadow-lg">
        <div className="flex justify-center mb-6">
          <div className="flex items-center justify-center w-16 h-16 rounded-full bg-green-100 text-green-600">
            <CheckCircle className="w-8 h-8" />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold mb-2">Thank You!</h1>
        <p className="text-muted-foreground mb-4">
          Your photo has been submitted successfully and is now under review.
        </p>
        
        <div className="bg-purple-50 text-purple-700 p-4 rounded-lg mb-6">
          <h3 className="font-semibold flex items-center justify-center gap-2 mb-2">
            <Gift className="h-5 w-5" />
            <span>$25 Store Credit Coming Soon!</span>
          </h3>
          <p className="text-sm">
            Once your photo is approved, we'll email you a $25 discount code 
            that you can use on your next purchase.
          </p>
        </div>
        
        <Button variant="outline" asChild className="w-full">
          <a href="/">
            Return to Homepage
          </a>
        </Button>
      </Card>
    </FadeIn>
  );
};

export default ThankYouScreen;
